import React, { useState } from 'react';
import { Form, Input, Button, Select } from 'antd';
import '../../index.css'

const { Option } = Select;
const MyForm = ({ triggerNextStep }) => {
  const [showMemberCodeInput, setShowMemberCodeInput] = useState(false);
  const [memberChoice, setMemberChoice] = useState('');

  const handleSubmit = (values) => {
    window._genesys.widgets.webchat.userData = values
    triggerNextStep();
  };

  const handleAnswer = (val) => {
    setShowMemberCodeInput(val === 'Yes' ? true : false);
    setMemberChoice(val);
  }

  return (
    <Form
      onFinish={handleSubmit}
      layout="vertical"
      style={{width:"90%"}}
      initialValues={window._genesys.widgets.webchat.userData}
    >
      <Form.Item
        name="lastName"
        rules={[{ required: true, message: 'Please enter your last name' }]}
      >
        <Input placeholder="Last name" />
      </Form.Item>
      <Form.Item
        name="firstName"
        rules={[{ required: true, message: 'Please enter your first name' }]}
      >
        <Input placeholder="First Name"/>
      </Form.Item>
      <Form.Item
        name="email"
        rules={[
          { required: true, message: 'Please enter your email address.' },
          { type: 'email', message: 'Please enter a valid email address.' },
        ]}
      >
        <Input placeholder="Email Address"/>
      </Form.Item>
      <Form.Item
        name="contactNumber"
        rules={[
          { required: true, message: 'Please enter your contact number.' },
          { pattern: /^[0-9]{11}$/, message: 'Please enter a valid 11-digit contact number.' },
        ]}
      >
        <Input placeholder="Contact Number" />
      </Form.Item>
      <Form.Item
        name="chooseAnswer"
        rules={[{ required: true, message: 'Please choose an answer.' }]}
      >
        <Select 
          className='custom-select'
          placeholder="Do you have a Member Code?" 
          onChange={(e) => handleAnswer(e)}
          value={memberChoice}
        >
          <Option value='Yes'>Yes</Option>
          <Option value='None'>None</Option>
        </Select>
      </Form.Item>
      <Form.Item>
        {showMemberCodeInput && <Input className='ember-code' name="memberCode" placeholder="Enter Member Code (Optional)" />}
      </Form.Item>
      <Form.Item>
        <Button 
          type="primary" 
          htmlType="submit"
          style = {{
            borderRadius: "0px",
            width:"100%",
            marginTop: "20px",
            height: "50px",
            paddingTop: "0px"
          }}
        >
          Submit
        </Button>
      </Form.Item>
    </Form>
  );
};

export default MyForm;